import { decode } from 'jsonwebtoken'
import AppointmentEventLogData from '../Models/AppointmentEventLogData'

const extractJWTData = (token: string): AppointmentEventLogData | null => {
  try {
    const decoded = decode(token, { complete: true })
    const eventLog = decoded?.payload as AppointmentEventLogData
    if (eventLog && (eventLog.PatientName === '' || eventLog.SpecialistName === '' || eventLog.ExamName === '')) {
      return null
    }
    return eventLog ?? null
  } catch (e) {
    return null
  }
}

export default extractJWTData
